import * as deviceDetect from "deviceDetect";
import * as localAPI from "localAPI";
import * as modalController from "modalController";
import * as preact from "preact";
import Dialog from "views/Dialog";
import { SignupComponent } from "views/SignupView";

export const show = (options) => {
  options = options ?? {};
  const signupComponentRef = preact.createRef<SignupComponent>();

  const finalOptions = {
    // Default options
    create: true,
    minHeight: 385,
    title: "signup",
    width: deviceDetect.isSmall() ? 290 : 400, // XXX Conditional on screen size
    undoZoom: true,

    // Custom options
    ...options,

    onShow: () => {
      signupComponentRef.current?.setFocus();
      options?.onShow?.();
    },
  };

  const component = preact.h(
    Dialog,
    { class: "signupDialog", heading: options.heading ?? "Let's get started!" },
    preact.h(SignupComponent as any, {
      ref: signupComponentRef,
      stores: options.stores,
    })
  );

  if (!modalController.show(component, finalOptions)) {
    throw new Error("Signup modal host is not mounted");
  }
};

/**
 * For actions that need an account: shows the signup modal and returns true
 * if signed out (in local mode), where the server would refuse the request.
 */
export const showIfSignedOut = async (options) => {
  if (!(await localAPI.isLocalMode())) {
    return false;
  }
  show(options);
  return true;
};
